export default function () {
  return {
    priceLists: {}
  }
}
